import _taggedTemplateLiteral from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _defineProperty from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";

var _templateObject, _templateObject2;

import _regeneratorRuntime from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useState } from 'react';
import Image from 'next/legacy/image';
import { useRouter } from 'next/router';
import styled from 'styled-components';
import { Form, Formik } from 'formik';
import HTTPMethod from 'http-method-enum';
import { useTranslation, Trans } from '@yoweb/next-i18next';
import { Container } from '@yoweb/ui/components/containers';
import { Grid } from '@yoweb/ui/components/Grid';
import { Spacer } from '@yoweb/ui/components/Spacer';
import { ButtonLink, Button } from '@yoweb/ui/components/buttons';
import { Title, Text, Label } from '@yoweb/ui/components/typography';
import { getColor, getRadii, getSpace } from '@yoweb/ui/styles/utils/theme';
import { media, pxToRem } from '@yoweb/ui/styles/utils';
import form, { getTopicsOptions } from './form';
import { useYoForm } from '@yoweb/ui/hooks/forms';
import useReCaptcha from '@store/hooks/useReCaptcha';
import { ACTION_CONTACT_FORM_SUBMISSION } from '@store/constants/recaptcha';
import { fetchJson } from '@yoweb/utils/fetchJson';
import { API_CONTACT_FORM_SUBMISSION, PAGE_EMPLOYERS, PAGE_FAQ, PAGE_PRIVACY_POLICY } from '@store/constants/routes';
import { useError, ErrorDisplay, Select, Input, Textarea } from '@yoweb/ui/components/form';
import NameGrid from '@yoweb/ui/components/NameGrid';
import { useIntlMeta } from '@yoweb/ui/hooks/useIntlMeta';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var IDS = {
  submit: 'contact-us-submit',
  form: 'contact-us-form',
  error: 'contact-us-error',
  success: 'contact-us-success'
};
var fieldSetRowGapWidth = pxToRem(18);
/**
 * The Contact us page.
 */

export var ContactUs = function ContactUs() {
  var _useTranslation = useTranslation(['common', 'contact-us']),
      t = _useTranslation.t,
      i18n = _useTranslation.i18n;

  var _useIntlMeta = useIntlMeta(),
      lcLocale = _useIntlMeta.lcLocale;

  var isJapanLocale = lcLocale === 'ja-jp';

  var _useRouter = useRouter(),
      query = _useRouter.query;

  var defaultTopic = query === null || query === void 0 ? void 0 : query.topic;
  var options = getTopicsOptions(t);
  var yoForm = useYoForm(['common'], form(defaultTopic));
  var reCaptcha = useReCaptcha();
  var errorDisplay = useError();

  var _useState = useState(false),
      success = _useState[0],
      setSuccess = _useState[1];

  var handleSubmit = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(values, helpers) {
      var reCaptchaToken;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              errorDisplay.clear();
              _context.prev = 1;
              _context.next = 4;
              return reCaptcha.execute(ACTION_CONTACT_FORM_SUBMISSION);

            case 4:
              reCaptchaToken = _context.sent;
              _context.next = 7;
              return fetchJson(API_CONTACT_FORM_SUBMISSION, {
                method: HTTPMethod.POST,
                body: JSON.stringify(_objectSpread(_objectSpread({}, values), {}, {
                  locale: i18n.language,
                  reCaptchaToken: reCaptchaToken
                }))
              });

            case 7:
              setSuccess(true);
              _context.next = 15;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](1);
              errorDisplay.set({
                title: t('common:error.title'),
                message: t('common:error.description')
              });
              helpers.setSubmitting(false);
              throw _context.t0;

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 10]]);
    }));

    return function handleSubmit(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();

  var showError = Boolean(errorDisplay.message);
  var contactUsTransComponents = isJapanLocale ? [/*#__PURE__*/_jsx(ButtonLink, {
    variant: "muted",
    weight: "bold",
    href: PAGE_FAQ
  }, 0), /*#__PURE__*/_jsx(ButtonLink, {
    variant: "muted",
    weight: "bold",
    href: PAGE_EMPLOYERS
  }, 1)] : [/*#__PURE__*/_jsx(ButtonLink, {
    variant: "muted",
    weight: "bold",
    href: PAGE_FAQ
  }, 0)];
  return /*#__PURE__*/_jsx(ContactUsLayout, {
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsxs(ContactUsContainer, {
        children: [/*#__PURE__*/_jsxs(FormHeader, {
          children: [/*#__PURE__*/_jsx(Label, {
            size: {
              xs: 'sm',
              md: 'md'
            },
            $textTransform: "capitalize",
            children: t('contact-us:label')
          }), /*#__PURE__*/_jsx(Title, {
            size: "xl",
            children: t('contact-us:title')
          }), /*#__PURE__*/_jsx(Text, {
            size: "xl",
            variant: "muted",
            whiteSpace: "pre-wrap",
            children: /*#__PURE__*/_jsx(Trans, {
              t: t,
              i18nKey: "contact-us:subtitle",
              components: contactUsTransComponents
            })
          }), success && /*#__PURE__*/_jsxs(SuccessContainer, {
            "data-testid": IDS.success,
            children: [/*#__PURE__*/_jsx(Title, {
              size: "sm",
              children: t('contact-us:success.title')
            }), /*#__PURE__*/_jsx(Text, {
              size: "lg",
              variant: "muted",
              whiteSpace: "pre-wrap",
              children: t('contact-us:success.subtitle')
            })]
          })]
        }), /*#__PURE__*/_jsx(ImageContainer, {
          children: /*#__PURE__*/_jsx(Image, {
            src: "/images/illustrations/listening.png",
            alt: t('contact-us:alt-text'),
            layout: "fill",
            objectFit: "contain",
            objectPosition: "top",
            priority: true
          })
        }), !success && /*#__PURE__*/_jsxs(FormContainer, {
          children: [showError && /*#__PURE__*/_jsx(ErrorDisplay, _objectSpread(_objectSpread({
            withBorder: true
          }, errorDisplay), {}, {
            "data-testid": IDS.error
          })), /*#__PURE__*/_jsx(Formik, {
            initialValues: yoForm.initialState,
            validationSchema: yoForm.schema,
            onSubmit: handleSubmit,
            enableReinitialize: true,
            children: function children(_ref2) {
              var isSubmitting = _ref2.isSubmitting,
                  isValid = _ref2.isValid,
                  dirty = _ref2.dirty;
              return /*#__PURE__*/_jsxs(Form, {
                "data-testid": IDS.form,
                children: [/*#__PURE__*/_jsxs(Fieldset, {
                  role: "group",
                  "aria-labelledby": "topic-title",
                  children: [/*#__PURE__*/_jsx(Text, {
                    weight: "bold",
                    size: "xl",
                    id: "topic-title",
                    children: t('contact-us:form.topic.title')
                  }), /*#__PURE__*/_jsx(Select, {
                    id: "topic",
                    name: "topic",
                    label: t('contact-us:form.topic.label'),
                    options: options,
                    "data-testid": "contact-us-topic-select"
                  })]
                }), /*#__PURE__*/_jsx(Spacer, {
                  size: "normal3"
                }), /*#__PURE__*/_jsxs(Fieldset, {
                  role: "group",
                  "aria-labelledby": "information-title",
                  children: [/*#__PURE__*/_jsx(Text, {
                    weight: "bold",
                    size: "xl",
                    id: "information-title",
                    children: t('contact-us:form.information.title')
                  }), /*#__PURE__*/_jsxs(Grid, {
                    gap: "normal2",
                    children: [/*#__PURE__*/_jsxs(NameGrid, {
                      needsPronunciationFields: false,
                      rowGap: "normal2",
                      children: [/*#__PURE__*/_jsx(Input, {
                        id: "givenName",
                        name: "givenName",
                        label: t('common:form.first-name.label')
                      }), /*#__PURE__*/_jsx(Input, {
                        id: "familyName",
                        name: "familyName",
                        label: t('common:form.last-name.label')
                      })]
                    }), /*#__PURE__*/_jsx(Input, {
                      id: "email",
                      name: "email",
                      type: "email",
                      label: t('common:form.email.label')
                    }), /*#__PURE__*/_jsx(Textarea, {
                      id: "description",
                      name: "description",
                      label: t('contact-us:form.information.how-can-we-help-placeholder')
                    })]
                  })]
                }), /*#__PURE__*/_jsx(Spacer, {
                  size: "normal2"
                }), /*#__PURE__*/_jsx(Text, {
                  size: "sm",
                  variant: "muted",
                  children: /*#__PURE__*/_jsx(Trans, {
                    t: t,
                    i18nKey: "contact-us:small-print",
                    components: [/*#__PURE__*/_jsx(ButtonLink, {
                      size: "sm",
                      variant: "muted",
                      weight: "regular",
                      href: PAGE_PRIVACY_POLICY
                    }, 0)]
                  })
                }), /*#__PURE__*/_jsx(Spacer, {
                  size: "normal2"
                }), /*#__PURE__*/_jsx(Button, {
                  size: "lg",
                  type: "submit",
                  "data-testid": IDS.submit,
                  isLoading: isSubmitting,
                  isDisabled: !(dirty && isValid),
                  children: t('common:submit')
                })]
              });
            }
          })]
        })]
      })
    })
  });
};
var ContactUsLayout = styled.div.withConfig({
  componentId: "sc-1c4jf4t-0"
})(["background:", ";padding:", " 0 ", ";", ""], getColor('base050'), pxToRem(144), pxToRem(112), media.lg(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    padding: ", " 0 ", ";\n  "])), pxToRem(200), getSpace('xl2')));
var ContactUsContainer = styled.div.withConfig({
  componentId: "sc-1c4jf4t-1"
})(["display:grid;grid-gap:", " ", ";grid-template:'title' auto 'image' ", " 'form' auto;padding:0;position:relative;", ""], getSpace('medium2'), getSpace('xl2'), pxToRem(236), media.lg(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  grid-template: \n    \"title  image\" auto\n    \"form  image\" 1fr / 4fr 3fr;\n  padding: 0 ", ";\n"])), pxToRem(104)));
var SuccessContainer = styled.div.withConfig({
  componentId: "sc-1c4jf4t-2"
})(["background:", ";border-radius:", ";display:grid;grid-auto-flow:row;margin-top:", ";padding:", " ", " ", ";row-gap:", ";"], getColor('base000'), getRadii('medium'), getSpace('normal2'), getSpace('normal2'), getSpace('normal3'), getSpace('normal3'), getSpace('small3'));
var FormContainer = styled.div.withConfig({
  componentId: "sc-1c4jf4t-3"
})(["display:grid;grid-area:form;grid-auto-flow:row;row-gap:", ";"], getSpace('normal2'));
var Fieldset = styled.div.withConfig({
  componentId: "sc-1c4jf4t-4"
})(["display:grid;row-gap:", ";"], fieldSetRowGapWidth);
var ImageContainer = styled.div.withConfig({
  componentId: "sc-1c4jf4t-5"
})(["grid-area:image;position:relative;text-align:center;"]);
var FormHeader = styled.div.withConfig({
  componentId: "sc-1c4jf4t-6"
})(["display:grid;grid-auto-flow:row;grid-area:title;row-gap:", ";"], getSpace('normal1'));
export default ContactUs;